import { useState, useEffect, memo } from "react";
import style from "./../index.module.scss";
import { CSSTransition } from 'react-transition-group';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import CheckIcon from '@mui/icons-material/Check';
import Tab1Content from "../../pages/Tab1/Tab1Content";
import Tab2Content from "../../pages/Tab2/Tab2Content";

const Tab2Template = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);

    useEffect(() => {
        setInProp(true);
        document.title = "公益";
    }, []);

    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "Tab2Template"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <Tab2Content addModalType={addModalType} setModalType={setModalType} type="friend" friendVo={arg.friendVo} onExitCb={res=>{
                                setInProp(false);
                            }}/>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Tab2Template);
